import {
  MappedPanelError,
  mapPanelError,
  PanelErrorRoute,
} from "../panelErrors";
import { BrokerageTransferFormValues } from "./types";

export type BrokerageTransferErrorField = keyof BrokerageTransferFormValues;

export type MappedBrokerageTransferError =
  MappedPanelError<BrokerageTransferErrorField>;

/** Where a rejected brokerage transfer lands. Most-specific prefixes stay first. */
const ROUTES: readonly PanelErrorRoute<BrokerageTransferErrorField>[] = [
  ["Transaction Date should be after the", "date"],
  ["Transaction Amount", "amountEur"],
  ["Amount ", "amountEur"],
  [
    "A transfer can move money into or out of one holdings-ledger account",
    null,
  ],
  ["Cannot create transfers using liabilities accounts", null],
];

export const mapBrokerageTransferError = (
  messages: string[],
): MappedBrokerageTransferError => mapPanelError(messages, ROUTES);
